import {t} from 'ttag';

const countryMap: Record<string, string> = {
  PT: t`Portugal`,
  US: t`United States`,
  FR: t`France`,
  ES: t`Spain`,
  DE: t`Germany`,
  IT: t`Italy`,
  BR: t`Brazil`,
  JP: t`Japan`,
  CN: t`China`,
  IN: t`India`,
  GB: t`United Kingdom`,
  CA: t`Canada`,
  AU: t`Australia`,
  MX: t`Mexico`,
  RU: t`Russia`,
  ZA: t`South Africa`,
  KR: t`South Korea`,
  AR: t`Argentina`,
  CL: t`Chile`,
  SE: t`Sweden`,
  NO: t`Norway`,
  FI: t`Finland`,
  NL: t`Netherlands`,
  BE: t`Belgium`,
  CH: t`Switzerland`,
  AT: t`Austria`,
  DK: t`Denmark`,
  IE: t`Ireland`,
  NZ: t`New Zealand`,
  PL: t`Poland`,
  CZ: t`Czech Republic`,
  HU: t`Hungary`,
  GR: t`Greece`,
  TR: t`Turkey`,
  EG: t`Egypt`,
  SA: t`Saudi Arabia`,
  AE: t`United Arab Emirates`,
  TH: t`Thailand`,
  VN: t`Vietnam`,
  MY: t`Malaysia`,
  ID: t`Indonesia`,
  PH: t`Philippines`,
  SG: t`Singapore`,
  HK: t`Hong Kong`,
  TW: t`Taiwan`,
  PK: t`Pakistan`,
  BD: t`Bangladesh`,
  NG: t`Nigeria`,
  KE: t`Kenya`,
  GH: t`Ghana`,
  CO: t`Colombia`,
  VE: t`Venezuela`,
  PE: t`Peru`,
  UY: t`Uruguay`,
  BO: t`Bolivia`,
  EC: t`Ecuador`,
  RO: t`Romania`,
  BG: t`Bulgaria`,
  SK: t`Slovakia`,
  SI: t`Slovenia`,
  HR: t`Croatia`,
  LT: t`Lithuania`,
  LV: t`Latvia`,
  EE: t`Estonia`,
  IS: t`Iceland`,
  MT: t`Malta`,
  CY: t`Cyprus`,
  LU: t`Luxembourg`,
  IL: t`Israel`,
  JO: t`Jordan`,
  LB: t`Lebanon`,
  OM: t`Oman`,
  QA: t`Qatar`,
  KW: t`Kuwait`,
  BH: t`Bahrain`,
  IR: t`Iran`,
  IQ: t`Iraq`,
  SY: t`Syria`,
  YE: t`Yemen`,
  AF: t`Afghanistan`,
  LK: t`Sri Lanka`,
  MM: t`Myanmar`,
  KH: t`Cambodia`,
  LA: t`Laos`,
  NP: t`Nepal`,
  BT: t`Bhutan`,
  MV: t`Maldives`,
  KZ: t`Kazakhstan`,
  UZ: t`Uzbekistan`,
  TM: t`Turkmenistan`,
  KG: t`Kyrgyzstan`,
  TJ: t`Tajikistan`,
  MN: t`Mongolia`,
  AZ: t`Azerbaijan`,
  GE: t`Georgia`,
  AM: t`Armenia`,
  BY: t`Belarus`,
  UA: t`Ukraine`,
  MD: t`Moldova`,
  RS: t`Serbia`,
  BA: t`Bosnia and Herzegovina`,
  ME: t`Montenegro`,
  MK: t`North Macedonia`,
  AL: t`Albania`,
  XK: t`Kosovo`,
  CU: t`Cuba`,
  DO: t`Dominican Republic`,
  HT: t`Haiti`,
  JM: t`Jamaica`,
  TT: t`Trinidad and Tobago`,
  BB: t`Barbados`,
  BS: t`Bahamas`,
  AG: t`Antigua and Barbuda`,
  LC: t`Saint Lucia`,
  VC: t`Saint Vincent and the Grenadines`,
  GD: t`Grenada`,
  KN: t`Saint Kitts and Nevis`,
  FJ: t`Fiji`,
  WS: t`Samoa`,
  TO: t`Tonga`,
  SB: t`Solomon Islands`,
  VU: t`Vanuatu`,
  PG: t`Papua New Guinea`,
  NR: t`Nauru`,
  TV: t`Tuvalu`,
  KI: t`Kiribati`,
  MH: t`Marshall Islands`,
  FM: t`Micronesia`,
  PW: t`Palau`
};

export function getCountryName(countryCode: string): string {
  return countryMap[countryCode] || countryCode;
}
